var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9718 86.0497L176 48.1481L314.028 86.0497V157.95L176 195.852L37.9718 157.95V86.0497Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 47.5,
    r: 11.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.5,
    cy: 85.5,
    r: 11.5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 85.5,
    r: 11.5,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.5,
    cy: 157.5,
    r: 11.5,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 157.5,
    r: 11.5,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 196.5,
    r: 11.5,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.36 148.57L104.35 125.98V116.26L139.36 93.67V106.63L116.05 120.94V121.3L139.36 135.61V148.57ZM210.57 148.57V135.61L233.88 121.3V120.94L210.57 106.63V93.67L245.58 116.26V125.98L210.57 148.57Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.664 93.6055L162.664 150.605",
    stroke: "currentColor",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramework);
export default __webpack_public_path__ + "static/media/framework.fe3e52d2d852c4539970de3cf7b42209.svg";
export { ForwardRef as ReactComponent };